/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';

/**
 * A simple hook to get and return pattern stores.
 */
export const usePatternStores = () => {
    const { dispatcher, rootStore } = useGlobalState();
    const currentAppVersion = rootStore.currentLuisAppStore.currentAppVersionStore;
    const patternStores = currentAppVersion.patternStoreHouse.items;
    const arePatternStoresLoading = currentAppVersion.patternStoreHouse.isLoading;

    React.useEffect(() => dispatcher.dispatch('loadPatterns'), []);

    return { patternStores, arePatternStoresLoading };
};
